// Размер буфера отрисовки игрового поля: его считает HexGrid при создании
// сцены и GameScene.resizeToWindow при изменении размера окна — оба обязаны
// получать одно и то же, иначе после ресайза канва растянулась бы иначе, чем
// при создании

// Предохранитель на плотность пикселей буфера отрисовки. У сегодняшних
// устройств DPR выше 3 практически не встречается, так что резкость порог
// нигде не режет — он страхует от экзотики с 4x и выше.
//
// Снижать его до 2 пробовали — на экранах с DPR 3 появлялась заметная
// лестница по краям иконок: буфер меньше физической области, и браузер
// растягивает его обратно (края спрайтов — альфа текстуры, их сглаживает
// только разрешение). После отключения Pre/Post FX (см. конфиг игры в
// HexGrid) платить за полный DPR стало дешево: видеопамять растет линейно от
// площади (канва плюс четыре буфера UtilityPipeline), а не кубически,
// как было с пулом FX. Остается филлрейт: при DPR 3 GPU закрашивает в 2.25
// раза больше фрагментов на кадр, чем при 2 — если когда-нибудь понадобится
// его урезать, правильнее ограничивать не DPR, а ПЛОЩАДЬ буфера:
// scale = min(DPR, sqrt(бюджет_пикселей / площадь_в_CSS)) — тогда маленькие
// экраны остаются резкими, а большие не получают непосильной нагрузки
const MAX_DPR = 3;

export const getFieldDpr = () => Math.min(window.devicePixelRatio || 1, MAX_DPR);

// Размеры сцены уходят в gl.texImage2D для каждого render target'а, поэтому
// обязаны быть целыми и положительными: дробные (безопасная зона и DPR
// дают дробь легко) и тем более нулевые размеры дают невалидную текстуру
// и падение в буте с «Framebuffer status: Incomplete Attachment»
export const toBufferSize = (cssPixels, dpr = getFieldDpr()) => Math.max(1, Math.round(cssPixels * dpr));

/**
 * Буфер поля матча — все окно (поле лежит под шапкой, футером и панелями)
 * @param {number} [dpr]
 * @returns {{width: number, height: number}} в буферных пикселях
 */
export const getMatchFieldBufferSize = (dpr = getFieldDpr()) => ({
  width: toBufferSize(window.innerWidth, dpr),
  height: toBufferSize(window.innerHeight, dpr),
});
